import {FC} from 'react'

type Props = {
  two_steps?: boolean
}

const TransactionTwoStepsCell: FC<Props> = ({two_steps}) => (
  <> {two_steps && <div className='badge badge-success fs-4  fw-bolder'>Success</div>}</>
)

export {TransactionTwoStepsCell}
